import React, {useEffect} from "react";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import BulkPriceChangeDashboard from "./dashboard";
import NewBulkPriceChangeView from "./new-bulk-price-change";
import BulkPriceChangeReport from "./bulk-price-change-report";
import {matchPath} from "react-router";


/**
 * Different step ids for creating a new bulk price change that comes from the server.
 */
export const NewBulkPriceChangeServerStatusIds = {
    productSelection: 1,
    priceLevelSelection: 2,
    changePrice: 3,
    reviewAndFinalize: 4,
    finalized: 5,
}

const PriceBulkChangeViews = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route, and if it is "/bulk-price-change", appends "/dashboard" to it.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.products.bulkPriceChange.base, exact: true})) {
            history.replace(routes.products.bulkPriceChange.dashboard);
        }
    }, [history, location.pathname]);

    return (
        <Switch>
            <Route path={routes.products.bulkPriceChange.dashboard} exact>
                <BulkPriceChangeDashboard/>
            </Route>
            <Route path={routes.products.bulkPriceChange.newBulkPrice} exact>
                <NewBulkPriceChangeView/>
            </Route>
            <Route path={routes.products.bulkPriceChange.report} exact>
                <BulkPriceChangeReport/>
            </Route>
        </Switch>
    );
}

export default PriceBulkChangeViews;
